(function () {
  var STORAGE_KEY = 'ssWelcomePopupDismissedUntil';
  var DISMISS_DAYS = 20;

  function isDismissed() {
    try {
      var until = window.localStorage.getItem(STORAGE_KEY);
      return until && Number(until) > Date.now();
    } catch (e) {
      return false;
    }
  }

  function rememberDismissal(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {
      /* localStorage kapalıysa sessizce yok say */
    }
  }

  function init() {
    var popup = document.getElementById('welcomePopup');
    if (!popup) return;

    var wasSubmittedSuccessfully = !!popup.querySelector('.welcome-popup__success');

    // Form başarıyla gönderildiyse (sayfa "form.posted_successfully?" ile yeniden
    // yüklendiyse): teşekkür mesajını göster ama kalıcı olarak (60 gün) bir daha çıkma.
    if (wasSubmittedSuccessfully) {
      rememberDismissal(60);
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
      bindCloseHandlers(popup);
      return;
    }

    if (isDismissed()) return;

    var delay = parseInt(popup.dataset.delayMs, 10) || 3000;
    setTimeout(function () {
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
    }, delay);

    bindCloseHandlers(popup);
  }

  function bindCloseHandlers(popup) {
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.classList.remove('is-visible');
        setTimeout(function () {
          popup.hidden = true;
        }, 300);
        rememberDismissal(DISMISS_DAYS);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
        popup.classList.remove('is-visible');
        setTimeout(function () {
          popup.hidden = true;
        }, 300);
        rememberDismissal(DISMISS_DAYS);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
